import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import {ArrowBack} from "@mui/icons-material";
import {useGetEventPilotsQuery} from "../../slices/apiSlice";
import {
    countryArray, isViableRegistrationStatus, registrationStatus
} from "../../util/standards-util";
import {Alert, Dialog, DialogContent, Stack} from "@mui/material";
import {findFlagUrlByIso2Code} from 'country-flags-svg';
import Tooltip from "@mui/material/Tooltip";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import {StyledTableCell, StyledTableRow} from "../../components/Event/EventTable";
import {SGP} from "../Competition/sgp-results-react";
import {getEventDatesString} from "../Calendar";
import {sortEntriesPerSgpRules} from "./PilotRegistrationList";


export const normalize = (v) => {
    return v > 0 ? 1 : v < 0 ? -1 : 0
}

export const mapRegistrationStatusToComparable  = (u)=> {
    switch(u) {
        case registrationStatus.STATUS_OK : return 2;
        case registrationStatus.STATUS_CANCELED : return 1;
        case registrationStatus.STATUS_BANNED : return 0;
        case registrationStatus.STATUS_SUBMITTED : return 2;
        case registrationStatus.STATUS_PRELIMINARY : return 2;
        case registrationStatus.STATUS_PENDING : return 2;
        case registrationStatus.STATUS_REJECTED : return 1;
        case registrationStatus.STATUS_APPROVED : return 2;
        case registrationStatus.STATUS_RESUBMITTED : return 1;
        case registrationStatus.STATUS_ON_PROBATION : return 0;
        case registrationStatus.STATUS_WITHDRAWN : return 1;
    }
}


const PublicPilotRegistrationList = ({event}) => {

    const eventId = event.id
    const eventCountry = event.country
    const eventEntryNo = 20
    const [mode, setMode] = React.useState('list')
    const [entries, setEntries] = React.useState()
    const [pilotRlId, setPilotRlId] = React.useState()

    const {data, isSuccess} =
        useGetEventPilotsQuery(eventId)


    const handlePilotClicked = (e,id) => {
        e.stopPropagation()
        setPilotRlId(id)
        setMode('rlPilotInfo')
    }


    useEffect(() => {
        if (isSuccess) {

            const entries = sortEntriesPerSgpRules(
                data.registrations.map((reg)=>{
                    return {
                        registration:reg,
                        pilot:data.pilots.find(p => p.id === reg.p),
                    }
                }),
                event
            )

            setEntries(entries)
        }
    }, [isSuccess]);

    const onCloseRlPilotInfo = () => {
        setMode('list')
        setPilotRlId()
    }


    return (
        <>
            <Box sx={{
                display:'flex',
                alignItems:'center',
                //justifyContent:'space-between',
                my:'1em',
                columnGap:'2em',
            }}>
                <Typography variant={'h2'} flexGrow={1} textAlign={'left'}>Pilots</Typography>
            </Box>
            <Box sx={{textAlign:'left',bgcolor:'#113248',color:'#ffffff'}} mb={3} p={2}>
                <Stack direction={'row'}>
                    <Box mr={'24px'}>
                        <img src='/etc/img/sgp-series-logo-v3.png' alt="SGP" style={{width:'160px'}}/>
                    </Box>
                    <Box>
                        <Typography variant={'h5'}>{SGP.getChampionshipTitle(event)}</Typography>
                        <Typography variant={'h5'}>{event.fullEditionTitle}</Typography>
                        <Typography variant={'h6'}>{event.venue}</Typography>
                        <Typography variant={'h6'}>{getEventDatesString(event)}</Typography>
                    </Box>
                </Stack>
            </Box>
            {entries && mode === 'list' &&
                <TableContainer component={'div'}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>#</StyledTableCell>
                                <StyledTableCell>Pilot</StyledTableCell>
                                <StyledTableCell sx={{textAlign:'center'}}>Nationality</StyledTableCell>
                                <StyledTableCell>Sailplane</StyledTableCell>
                                <StyledTableCell sx={{textAlign: 'right'}}>Ranking</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {entries.map((entry,idx) => {
                                const reg= entry.registration
                                const pilot = entry.pilot

                                const sx = idx < eventEntryNo && isViableRegistrationStatus(reg.u) ?
                                    {
                                        '&:last-child td, &:last-child th': {border: 0},
                                        "&:hover": {backgroundColor: "#D3EDF4 !important"},
                                    }
                                    :
                                    {
                                        '&:last-child td, &:last-child th': {border: 0},
                                        '& td, & th': {borderBottom: 'solid 1px #999999'},
                                        "&:hover": {backgroundColor: "#D3EDF4 !important"},
                                        '&:nth-of-type(even)': {
                                            backgroundColor:'#cccccc',
                                        },
                                        '&:nth-of-type(odd)': {
                                            backgroundColor:'#dddddd',
                                        },
                                    }


                                return (
                                    <StyledTableRow
                                        key={reg.i}
                                        sx={sx}
                                    >
                                        <StyledTableCell component="th" scope="row">
                                            {idx < eventEntryNo  && isViableRegistrationStatus(reg.u) ? idx + 1 : '-' }
                                        </StyledTableCell>
                                        <StyledTableCell><Link underline={"none"} onClick={(e) => {handlePilotClicked(e,reg.d)}} sx={{cursor:'pointer'}}>{pilot.firstname} {pilot.lastname}</Link></StyledTableCell>
                                        <StyledTableCell sx={{textAlign:'center'}}><Tooltip title={countryArray.find( c => c.key===pilot.nationality).label} arrow><img src={findFlagUrlByIso2Code(pilot.nationality)} style={{height:'1.2em'}}/></Tooltip></StyledTableCell>
                                        <StyledTableCell>{reg.f}</StyledTableCell>
                                        <StyledTableCell sx={{textAlign: 'right'}}>{reg.m ? reg.m : '-'}</StyledTableCell>
                                    </StyledTableRow>
                                )
                            })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            {entries && mode === 'list' && entries.length === 0 &&
                <Alert severity={'info'} sx={{textAlign:'center'}}>There are no pilots registered for this event</Alert>
            }
            { mode === 'rlPilotInfo' &&
                <Dialog onClose={onCloseRlPilotInfo} open={true} fullWidth maxWidth="lg">
                    <DialogContent sx={{height:'80vh',display:'flex',flexDirection:'column',alignContent:'center'}}>
                        <Box sx={{
                            display:'flex',
                            alignItems:'center',
                            //justifyContent:'space-between',
                            my:'1em',
                            columnGap:'2em',
                        }}>
                            <IconButton onClick={()=>{onCloseRlPilotInfo()}}><ArrowBack/></IconButton>
                            <Typography variant={'h4'} flexGrow={1} textAlign={'left'}>Pilot profile</Typography>
                        </Box>
                        <Box flexGrow={1}>
                            <iframe src={`https://rankingdata.fai.org/SGP_displaypilotdets.php?pilotid=${pilotRlId}`}
                                    height={'100%'}
                                    width={'100%'}
                                    style={{border:'none'}}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            }
        </>
    )
}

export default PublicPilotRegistrationList